import React from "react";

import { Box } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { IFileValidation } from "../interfaces/IFileValidation";

interface ValidationFormProps {
  validationData: IFileValidation; // Definimos el prop como un objeto
}

export const ValidationForm: React.FC<ValidationFormProps> = ({
  validationData,
}) => {
  const { noValid, noValidSize, noValidName } = validationData;
  return (
    <div>
      <Box mt={-2} ml={2} style={{ fontSize: 12, color: "red" }}>
        {noValid ? (
          <FormattedMessage id="fileValidation.ValidFiles" />
        ) : noValidSize ? (
          <FormattedMessage id="fileValidation.ValidDocumentalFilesSize" />
        ) : noValidName ? (
          <FormattedMessage id="fileValidation.ValidDocumentalName" />
        ) : null}
      </Box>
    </div>
  );
};

export default ValidationForm;
